import React from "react";
import {
  hasSuccessfulPaymentRecord,
} from "../payment/paymentCalculations";

export const RegistrationFeeSummarySection = ({
  formData,
  feeLoading,
  feeError,
  registrationFee,
  shouldApplyPaperDiscount,
  paperDiscountPercentage,
  currentPaperSequence,
}) => {
  if (!formData.categoryId) {
    return null;
  }

  const currencySymbol = formData.country === "India" ? "₹" : "$";
  const baseRate = parseFloat(registrationFee?.rate || 0);
  const discountAmount = shouldApplyPaperDiscount
    ? (baseRate * paperDiscountPercentage) / 100
    : 0;
  const payableBase = Math.max(0, baseRate - discountAmount);

  return (
    <div className="summary-section">
      <h4>Registration Fee</h4>
      {feeLoading ? (
        <div className="summary-row">
          <span className="summary-label">Fee:</span>
          <span className="summary-value">⏳ Calculating...</span>
        </div>
      ) : feeError ? (
        <div className="summary-row fee-error-row">
          <span className="summary-label">Fee:</span>
          <span className="summary-value">⚠️ {feeError}</span>
        </div>
      ) : registrationFee ? (
        <>
          <div className="summary-row">
            <span className="summary-label">Base Amount:</span>
            <span className="summary-value">
              {currencySymbol}
              {baseRate.toFixed(2)} ({registrationFee.currency})
            </span>
          </div>
          {shouldApplyPaperDiscount && paperDiscountPercentage > 0 && (
            <>
              <div className="summary-row">
                <span className="summary-label">Paper Sequence:</span>
                <span className="summary-value">#{currentPaperSequence}</span>
              </div>
              <div className="summary-row">
                <span className="summary-label">Paper Discount:</span>
                <span className="summary-value">
                  {paperDiscountPercentage.toFixed(2)}% (-{currencySymbol}
                  {discountAmount.toFixed(2)})
                </span>
              </div>
            </>
          )}
          <div className="summary-row">
            <span className="summary-label">Payable Registration Fee:</span>
            <span className="summary-value" style={{ fontWeight: "bold" }}>
              {currencySymbol}
              {payableBase.toFixed(2)} ({registrationFee.currency})
            </span>
          </div>
          {registrationFee.feeCategory && (
            <div className="summary-row">
              <span className="summary-label">Fee Type:</span>
              <span className="summary-value">
                {registrationFee.feeCategory.value}
              </span>
            </div>
          )}
          {registrationFee.validFrom && registrationFee.validTo && (
            <div className="summary-row">
              <span className="summary-label">Valid Period:</span>
              <span className="summary-value">
                {new Date(registrationFee.validFrom).toLocaleDateString()} -{" "}
                {new Date(registrationFee.validTo).toLocaleDateString()}
              </span>
            </div>
          )}
        </>
      ) : (
        <div className="summary-row fee-error-row">
          <span className="summary-label">Fee:</span>
          <span className="summary-value">
            {hasSuccessfulPaymentRecord(formData.payment)
              ? "Current fee configuration is unavailable; showing paid amount from payment history below"
              : "No matching registration fee found for the selected category"}
          </span>
        </div>
      )}
    </div>
  );
};
